import React, { useEffect, useState } from "react";
import DefaultLayout from "../../Defaultlayout/DefaultLayout";
import { Button, Card, Col, Row, Table, Modal, Input, Grid } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import {
  API_BASE_URL,
  DELETE_CITY,
  directToken,
  LIST_OF_CITY,
} from "../services/end_points";
import { _delete, _get } from "../services/service_api";
import AddCity from "./AddCity";
import EditCity from "./EditCity";
import { useRoleData } from "../Data/Roledata";

const { useBreakpoint } = Grid;
const CityList = ({ handleRole }) => {
  const { column, rows } = useRoleData({ handleRole });
  const isAdmin = rows.some((row) => row.userType === "Admin");
  const [currentPage, setCurrentPage] = useState(1);
  const [city, setCity] = useState([]);
  const [alert, setAlert] = useState(null);
  const [filteredCities, setFilteredCities] = useState([]);
  const pageSize = 8;
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const showModal = () => setIsModalVisible(true);

  const fetchData = async () => {
    try {
      const response = await _get(
        `${API_BASE_URL}${LIST_OF_CITY}`,
        directToken
      );
      if (response && response.data && response.data.list) {
        setCity(response.data.list);
        setFilteredCities(response.data.list);
        // fetchData();
      } else {
        console.error("Response data is not as expected:", response.data);
      }
    } catch (error) {
      console.error(
        "Error fetching locations:",
        error.response?.data || error.message || error
      );
    }
  };

  const updateUserList = (newUser) => {
    setCity((prevUser) => {
      // Check if the user is being added or updated
      const index = prevUser.findIndex(
        (user) => user.userid === newUser.userid
      );
      if (index === -1) {
        // Add new user
        return [...prevUser, newUser];
      } else {
        // Update existing user
        const updatedUsers = [...prevUser];
        updatedUsers[index] = newUser;
        return updatedUsers;
      }
    });
    setFilteredCities((prevFilteredUser) => {
      const index = prevFilteredUser.findIndex(
        (user) => user.userid === newUser.userid
      );
      if (index === -1) {
        // Add new user
        return [...prevFilteredUser, newUser];
      } else {
        // Update existing user
        const updatedUsers = [...prevFilteredUser];
        updatedUsers[index] = newUser;
        return updatedUsers;
      }
    });
    fetchData();
  };
  const updateCityListAfterEdit = (updatedCity) => {
    setCity((prevCity) =>
      prevCity.map((city) => (city.id === updatedCity.id ? updatedCity : city))
    );
    setFilteredCities((prevFilteredCities) =>
      prevFilteredCities.map((city) =>
        city.id === updatedCity.id ? updatedCity : city
      )
    );
  };

  const handleDelete = async (data) => {
    try {
      const response = await _delete(
        `${API_BASE_URL}${DELETE_CITY}${data}`,
        directToken
      );
      setAlert({
        type: "success",
        message: response.data.message || "City Deleted!",
      });
      fetchData();
    } catch (error) {
      console.error("Error deleting city:", error);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    const filtered = city.filter(
      (cityItem) => cityItem.city && cityItem.city.toLowerCase().includes(value)
    );
    setFilteredCities(filtered);
    setCurrentPage(1);
  };

  const paginatedData = filteredCities.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const columns = [
    {
      title: "Serial Number",
      dataIndex: "serialNumber",
      key: "serialNumber",
      render: (_, __, index) => index + 1 + (currentPage - 1) * pageSize,
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
    },
    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
      render: (_, record) => (
        <div>
          <Button
            size="small"
            style={{
              fontSize: "12px",
              padding: "4px 8px",
              border: "1px solid #0899f9",
              color: "#0899f9",
            }}
            onClick={() => handleEditforopup(record)}
          >
            <EditOutlined />
          </Button>
          {isAdmin && (
            <Button
              size="small"
              style={{
                marginLeft: "5px",
                fontSize: "12px",
                padding: "4px 8px",
                border: "1px solid #941717",
                color: "#941717",
              }}
              onClick={() => handleDelete(record.id)}
            >
              <DeleteOutlined />
            </Button>
          )}
        </div>
      ),
    },
  ];

  const screens = useBreakpoint();
  let modalWidth;
  if (screens.xl) {
    modalWidth = 350;
  } else if (screens.lg) {
    modalWidth = 250;
  } else if (screens.md) {
    modalWidth = 200;
  } else if (screens.sm) {
    modalWidth = 400;
  } else {
    modalWidth = 300;
  }

  const handleEditforopup = (record) => {
    setSelectedRecord({ ...record });
    setIsModalVisible(true);
    setIsEditing(true);
    // setSelectedRecord(null);
  };
  const closeModal = () => {
    setIsModalVisible(false);
    setIsEditing(false);
    setSelectedRecord(null); // Reset the selected record when modal is closed
  };
  return (
    <DefaultLayout>
      <Card style={{ width: "100%", minHeight: "600px", height: "100%" }}>
        <Row
          gutter={[12, 12]}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Col xs={24} sm={6} md={4} lg={4} xl={4}>
            <h2>City List</h2>
          </Col>
          <Col xs={24} sm={8} md={12} lg={8} xl={8}>
            <Input
              style={{
                width: "100%",
                height: "45px",
              }}
              placeholder="Search Cities"
              onChange={handleSearch}
            />
          </Col>
          <Col xs={24} sm={8} md={4} lg={4} xl={4}>
            <Button
              style={{
                backgroundColor: "#6499f1",
                color: "white",
                fontSize: "14px",
                fontWeight: "600",
                borderRadius: "10px",
                width: "100%",
                height: "48px",
                maxWidth: "200px",
              }}
              onClick={showModal}
            >
              Create City
            </Button>
          </Col>
        </Row>

        <Row gutter={[12, 12]} style={{ width: "100%" }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Table
              columns={columns}
              dataSource={paginatedData}
              rowKey="id"
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: filteredCities.length,
                onChange: handlePageChange,
                showSizeChanger: false,
              }}
              scroll={{ x: "max-content" }} // Ensures horizontal scrolling if necessary
              style={{ width: "100%" }} // Ensures table takes up full width
            />
          </Col>
        </Row>

        <Modal
          title={isEditing ? "Edit City" : "Create City"}
          visible={isModalVisible}
          onCancel={closeModal}
          footer={null}
          width={modalWidth}
        >
          {isEditing ? (
            <EditCity data={selectedRecord} />
          ) : (
            <AddCity updateUserList={updateUserList} />
          )}
        </Modal>
      </Card>
    </DefaultLayout>
  );
};

export default CityList;

// export default CityList;
